/**
 * The telemetry registry version this bundle was built with (vite.config.js `define`: a
 * hash of the generated registry JSON, the same value the server computes at load), or
 * "dev" when the define is absent; for the event context, so dashboards can mark where
 * coverage changed (P2 design §4.8).
 */
export const REGISTRY_VERSION =
  typeof __TELEMETRY_REGISTRY_VERSION__ === "string" && __TELEMETRY_REGISTRY_VERSION__
    ? __TELEMETRY_REGISTRY_VERSION__
    : "dev";
